// TODO: This is a duplicate of the bitlyLib.ts file in
// src/utils

import { env } from '@edge/env'

interface BitlyResponse {
    references: unknown
    link: string
    id: string
    long_url: string
    archived: boolean
    created_at: string
    custom_bitlinks: string[]
    tags: string[]
    deeplinks: [
        {
            guid: string
            bitlink: string
            app_uri_path: string
            install_url: string
            app_guid: string
            os: string
            install_type: string
            created: string
            modified: string
            brand_guid: string
        },
    ]
}

/**
 * "BRANDED_LINK_MONTHLY_LIMIT_EXCEEDED" error occurs if you have shortened more links than your account is configured for for the month.
 * The long URL will be returned if bitly link limit is hit.
 */
export const shorten = async (longUrl: string | null | undefined): Promise<string> => {
    if (!longUrl) {
        return ''
    }

    const token = env.REACT_APP_BITLY_ACCESS_TOKEN
    const groupGuid = env.REACT_APP_BITLY_GROUP_GUID
    const customDomain = env.REACT_APP_BITLY_CUSTOM_DOMAIN
    const bitlyUrl = 'https://api-ssl.bitly.com/v4/shorten'

    if (!token || !groupGuid || !customDomain) {
        console.error('BITLY ERROR: Missing environment variables')
        return longUrl
    }

    try {
        const data = {
            long_url: longUrl,
            domain: customDomain,
            group_guid: groupGuid,
        }
        const body = JSON.stringify(data)
        const headers = {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
        const res = await fetch(bitlyUrl, {
            method: 'POST',
            body,
            headers,
        })

        const json = await res.json()
        const { link } = json as BitlyResponse

        return link
    } catch (err) {
        console.error('BITLY ERROR:', JSON.stringify(err))
        return longUrl
    }
}
